import { render, staticRenderFns } from "./AwTable.vue?vue&type=template&id=464bbfd8&"
import script from "./AwTable.vue?vue&type=script&lang=js&"
export * from "./AwTable.vue?vue&type=script&lang=js&"
import style0 from "./AwTable.vue?vue&type=style&index=0&id=464bbfd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports